<template>
  <loading v-model:active="isLoading"
           :can-cancel="false"
           :on-cancel="onCancel"
           :is-full-page="fullPage"/>
  <div  v-if="!isLoading" class="products">

    <div style="text-align: center;font-size: 14px;color: #1fa29d;font-weight: bold;border-top: 3px solid #1fa29d;margin-top: 20px;position: relative;margin-bottom: 50px">
      <div  style="position: absolute;top:-26px;padding: 10px;right: 35%;background: #fff">
        طرح {{category_name}}
      </div>
      <div class="clearfix"></div>
      <h5 v-if="products.length==0 &&  subCat.length==0" style="margin-top: 50px">محصولی در این دسته بندی وجود ندارد</h5>
    </div>
    <template v-if="productsKalite.length>0"  v-for="(product, index)  in productsKalite" :key="index">
      <div class="col-12" style="padding: 5px 20px">
        <h3 style="padding: 10px;border-radius: 10px;color: #fff;text-align: center;font-size: 0.8rem;background: #1fa29d" @click="showProduct(product.id)">
          همین الان کالیته {{category_name}} را سفارش بده
        </h3>
      </div>
    </template>

    <new-sub-category :categorys="subCat" :category_name="category_name"></new-sub-category>
    <div class="col-6 float-right " v-for="(product, index)  in products" :key="index" style="padding: 0 5px" @click="showProduct(product.id)">
      <template v-if="product.composition_id==10">
      </template>
      <template v-else>
        <div class="col-12 float-right" style="position: relative;background: rgb(229 229 229);border-radius: 15px;margin-bottom: 18px;overflow: hidden;">
          <div  v-if="product.pic!=''" class="catItem" >
            <img :src="product.img_url" width="100%" height="auto" style="border-radius: 15px 15px 0 0"/>
          </div>
          <div class="col-12 float-right ">
            <div class="col-12 float-right text-center" style="direction: rtl;padding: 10px 5px">
              <div class="col-4 float-right " style="font-size: 0.8rem">
                کدکالا :
              </div>
              <div class="col-8 float-right " style="font-size: 0.8rem;text-align: left">
                {{product.title}}
              </div>

            </div>
            <div class="clearfix"></div>
            <div class="col-12 float-right text-center" style="margin-top: 5px;font-size: 0.6rem;direction: rtl;color: rgb(31, 162, 157);padding: 5px">
              <div class="col-6 float-right text-right">
                <span style="text-decoration-line: line-through;color: red">{{product.price_dis_format}} ریال</span><br/>
              </div>
              <div class="col-6 float-right text-left">
                {{product.price_format}} ریال
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
            <div style="padding: 10px;border-radius: 0 0 15px;text-align: center;background: rgb(115,1,1);color: #fff;font-weight: 800;font-size: 10px;margin: 10px auto 0;" >
              خرید محصول
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </template>

    </div>


  </div>

</template>

<script>
import http from "@/plugins/axios";
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

// Import Swiper styles
import 'swiper/css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import router from "@/router";
import NewCategory from "@/components/NewCategory.vue";
import NewSubCategory from "@/components/NewSubCategory.vue";
var numeral = require("numeral");
export default {
  components: {
    NewSubCategory,
    NewCategory,
    Loading,
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  name: 'new-products',
  data: () =>({
    formatLang: 'fa-IR',
    formatStyle: 'currency',
    formatCurrency: 'ریال',
    isLoading: true,
    fullPage: true,
    products :  {
      data: [],
    },
    subCat :  [],
    productsKalite :  [],
  }),
  methods: {
    showProduct(product_id){
      router.push("/product/"+product_id)
    },
    addtoBasket(product){
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.post("/basket/add",{
        product_id : product.id,
        val : product.val,
      }, { headers: { Authorization: AuthStr ,"Content-type": "multipart/form-data"} })
          .then(response => {
            this.isLoading = false;
            this.$toast.success("محصول با موفقیت به سبد خرید اضافه شد.", {

              theme: "toasted-primary",
              position: "top-right",
              duration : 5000,

            });
          })
          .catch((error) => {

          });
    },
    setprice(product){
      let price =0;
      product.showprice =  numeral(product.val*product.price).format("0,0");
      return product;
    },
    getPicLink() {
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/productsCategory/"+this.category, { headers: { Authorization: AuthStr } })
          .then(response => {
            this.products = response.data.data.products;
            this.subCat = response.data.data.categoris;
            this.productsKalite = response.data.data.productsKalite;
            // console.log(this.subCat);

            this.isLoading = false;
          })
          .catch((error) => {

          });
    },
  },
  mounted() {
    this.getPicLink();
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  props: [
    "category",
    "category_name"
  ],
}
</script>

<style scoped>
.catItem img {
  height: 110px;
  object-fit: cover !important;
}
.pro1{
  background: #ccc;
  border-radius: 20px;
  margin: 5px auto !important;
  padding: 15px !important;
}
.desc{
  font-size: 8px !important;
  font-family: iranyekan !important;
  margin-top: 10px;
  text-align: justify;
  padding: 6px;
}
.desc h2{
  text-align: center;
  font-size: 8px !important;
  font-family: iranyekan !important;

}
.desc p{
  font-size: 8px !important;
  font-family: iranyekan !important;
  margin-top: 10px;
}
.products{
  margin-bottom: 100px;
}
</style>